export const dateTime = 'DD/MM/YYYY hh:mm:ss a';
export const date = 'DD/MM/YYYY hh:mm:ss';
export const calendarDate = 'DD/MM/YYYY';
export const calendarTime = 'hh:mm:ss A';
export const calendarTimeTask = 'hh:mm:ss';
